import { render, staticRenderFns } from "./PdfModal.vue?vue&type=template&id=3d645928&"
import script from "./PdfModal.vue?vue&type=script&lang=ts&"
export * from "./PdfModal.vue?vue&type=script&lang=ts&"
import style0 from "./PdfModal.vue?vue&type=style&index=0&id=3d645928&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports